"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var HiddenInput = function HiddenInput(_ref) {
  var multiSelect = _ref.multiSelect,
      name = _ref.name,
      value = _ref.value;

  if (multiSelect) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, value.length > 0 ? value.map(function (optionValue) {
      return /*#__PURE__*/_react.default.createElement("input", {
        key: optionValue,
        name: name + "[]",
        type: "hidden",
        value: optionValue
      });
    }) : /*#__PURE__*/_react.default.createElement("input", {
      name: name + "[]",
      type: "hidden",
      value: ""
    }));
  }

  return /*#__PURE__*/_react.default.createElement("input", {
    name: name,
    type: "hidden",
    value: value
  });
};

HiddenInput.propTypes = {
  multiSelect: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
};
HiddenInput.defaultProps = {
  multiSelect: false,
  value: ''
};
HiddenInput.displayName = 'HiddenInput';
var _default = HiddenInput;
exports.default = _default;